import FullCycleOfPlant from '@components/FullCycleOfPlant/FullCycleOfPlant';
import ProductAccessories from '@components/ProductAccessories/ProductAccessories';
import Comments from '@components/Comments/Comments';
import ProductStickyButton from '@components/ProductStickyButton/ProductStickyButton';
import manageClickOutside from '@utils/manageClickOutside';
import axios from 'axios';
import ReactDOM from "react-dom";
import Map from "@components/Map/Map";
import React from "react";

FullCycleOfPlant();
ProductAccessories();
ProductStickyButton();

const productPage = document.querySelector('.Product');

const toggleOverlay = (currentTarget, needToRemove = false) => {
  let overlay = null;

  if (currentTarget) {
    overlay = document.querySelector(`#features-${currentTarget.dataset.id}`);
  } else {
    overlay = document.querySelector(`.js-featuresOverlay.open`);
  }

  const overlayAlreadyOpen = document.querySelector(`.js-featuresOverlay.open`);

  if (overlayAlreadyOpen) {
    overlayAlreadyOpen.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('relative');
    document.body.classList.remove('h-full');
    document.body.classList.remove('is-open');

    const featuresOpenButtons = document.querySelectorAll(
      '.js-openFeaturesOverlay'
    );
    featuresOpenButtons.forEach((featureButton) => {
      featureButton.classList.remove('pointer-events-none');
    });
    return;
  }

  if (overlay) {
    overlay.classList.toggle('open');
    document.body.classList.toggle('overflow-hidden');
    document.body.classList.toggle('relative');
    document.body.classList.toggle('h-full');
    document.body.classList.toggle('is-open');

    const featuresOpenButtons = document.querySelectorAll(
      '.js-openFeaturesOverlay'
    );
    featuresOpenButtons.forEach((featureButton) => {
      featureButton.classList.add('pointer-events-none');
    });
  }

  const listenerFunction = (event) =>
    manageClickOutside(
      event,
      '.js-openFeaturesOverlay',
      '.js-featuresOverlay',
      toggleOverlay
    );

  if (!needToRemove) {
    productPage.addEventListener('click', listenerFunction);
  } else {
    productPage.removeEventListener('click', listenerFunction);
  }
};

export const manageFeaturesButton = () => {
  const featuresOpenButtons = document.querySelectorAll(
    '.js-openFeaturesOverlay'
  );
  const featuresCloseButtons = document.querySelectorAll(
    '.js-closeFeaturesOverlay'
  );

  featuresOpenButtons.forEach((featureButton) => {
    featureButton.addEventListener('click', ({ currentTarget }) => {
      toggleOverlay(currentTarget);
    });
  });

  featuresCloseButtons.forEach((featureButton) => {
    featureButton.addEventListener('click', ({ currentTarget }) => {
      toggleOverlay(currentTarget, true);
    });
  });
};

manageFeaturesButton();

async function initMap() {
  const mapNode = document.querySelectorAll('.tryout-results-map');
  for (const node of mapNode) {
    if (node && node.dataset.tryoutProduct) {
      const { default: Map } = await import('@components/Map/Map');
      const { default: React } = await import('react');
      const { default: ReactDOM } = await import('react-dom');

      ReactDOM.render(
        <Map
          category={node.dataset.tryoutCategory || null}
          mainColor={node.dataset.tryoutBackground}
          product={node.dataset.tryoutProduct || []}
          independentType={node.dataset.tryoutIndependentType || 'classic'}
          testimonyType={node.dataset.tryoutTestimonyType || 'classic'}
          isForages={node.dataset.tryoutForages || false}
        />,
        node
      );
    }
  }
}

document.body.classList.contains('fourage') ? initTrialResultMap() : initMap();

const manageWhereCanIFind = () => {
  const buttons = document.querySelectorAll('[data-where-product]');
  const form = document.querySelector('[data-prospect-where-product]');
  const formContainer = document.querySelector(
    '[data-prospect-form-container]'
  );
  const alertProspectList = document.querySelector(
    '[data-alert-prospect-list]'
  );
  const listContainer = document.querySelector('[data-prospect-list]');

  if (!buttons) return;

  buttons.forEach((button) =>
    button.addEventListener('click', ({ currentTarget }) => {
      const overlay = document.querySelector('.js-overlayFindVariety');

      if (!overlay) return;

      window.dataLayer.push({
        event: 'WHERE_TO_FIND_VARIETY'
      });

      overlay.classList.toggle('open');
      document.body.classList.toggle('overflow-hidden');

      // we wait end of animation
      setTimeout(() => {
        // reset prospect modal
        formContainer.classList.remove('hidden');
        alertProspectList.classList.add('hidden');
        listContainer.classList.add('hidden');
        listContainer.innerHTML = '';
        listContainer.childNodes.forEach((node) =>
          listContainer.removeChild(node)
        );
      }, 300);
    })
  );

  if (!form) return;

  const storageKey = 'prospect-where-variety';

  // Hydrater si l'utilisateur à déjà remplis le formulaire.
  if (localStorage.getItem(storageKey)) {
    const entries = new URLSearchParams(
      localStorage.getItem(storageKey)
    ).entries();

    for (const [key, value] of entries) {
      const input = form.elements[key];

      if (input.name !== 'product_id') {
        input.value = value;
      }
    }
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const data = new FormData(form);
    const loader = document.querySelector('[data-prospect-loader]');
    const submitText = document.querySelector('[data-prospect-submit]');

    if (!loader) return;

    loader.classList.remove('hidden');
    submitText.classList.add('hidden');

    const url = '/open_api/product_ditributors';

    const { data: responseData, status } = await axios({
      method: 'POST',
      url,
      data
    });
    loader.classList.add('hidden');
    submitText.classList.remove('hidden');
    const zipcode = data.get('zipcode');
    const alert = document.querySelector('[data-prospect-alert]');

    if (status === 400) {
      // enlever le loader
      // une erreur est survenue

      if (!alert) return;

      alert.classList.remove('hidden');
      return;
    }

    alert.classList.add('hidden');
    localStorage.setItem(storageKey, new URLSearchParams(data).toString());

    // afficher la liste des distributeur
    formContainer.classList.add('hidden');

    if (!responseData || !responseData.length) {
      // message aucun distributeur de disponible.
      alertProspectList.classList.remove('hidden');
      return;
    }

    responseData.forEach((data) => {
      if (!data) return;
      const title = document.createElement('p');
      title.classList.add('OverlayFindVariety-itemTitle');
      title.innerText = data.Name;

      listContainer.appendChild(title);
      data.addresses.forEach((address) => {
        if (address.zipcode.slice(0, 2) !== zipcode.slice(0, 2)) {
          return null;
        }

        const item = document.createElement('div');
        item.classList.add('OverlayFindVariety-item');

        const listInfos = [
          { className: 'OverlayFindVariety-itemInfo', label: address.address },
          {
            className: 'OverlayFindVariety-itemInfo',
            label: `${address.zipcode}, ${address.city}`
          },
          {
            label: address.phone,
            needAnchorAroundText: true
          }
        ];

        listInfos.forEach(({ className, label, needAnchorAroundText }) => {
          const p = document.createElement('p');

          if (className) {
            p.classList.add(className);
          }

          if (needAnchorAroundText && address.phone !== null) {
            const a = document.createElement('a');

            a.classList.add(
              'OverlayFindVariety-itemInfo',
              'btn',
              'btn--link',
              'w-max'
            );
            a.href = `tel:${address.phone}`;
            a.innerText = address.phone;

            p.appendChild(a);
          } else {
            p.innerText = label;
          }

          item.appendChild(p);
        });

        listContainer.appendChild(item);
        listContainer.classList.remove('hidden');
        listContainer.scrollTop = 0;
      });
    });
  });
};

manageWhereCanIFind();

const manageDDL = () => {
  const button = document.querySelector('.js-download');

  if (!button) return;

  button.addEventListener('click', ({ currentTarget }) => {
    window.dataLayer.push({
      event: 'TECHNICAL_SHEETS_DOWNLOAD'
    });

    window.open(currentTarget.dataset.href, currentTarget.dataset.target);
  });
};

manageDDL();
Comments();

function initTrialResultMap() {
  const node = document.querySelector('.tryout-results-map');
  if (node && node.dataset.tryoutCategory) {
    ReactDOM.render(
        <Map
            category={node.dataset.tryoutCategory || null}
            mainColor={node.dataset.tryoutBackground}
            seasons={
              node.dataset.tryoutSeason
                  ? JSON.parse(node.dataset.tryoutSeason)
                  : []
            }
            independentType={node.dataset.tryoutIndependentType || 'classic'}
            testimonyType={node.dataset.tryoutTestimonyType || 'classic'}
            isForages={true}
        />,
        node
    );
  }
}
